import { __ } from '@wordpress/i18n';
import classnames from 'classnames';
import reactStringReplace from 'react-string-replace';

import Modal from '../modal';
import { ModalContent, ModalActions, Input, RadioGroup, Select, Button } from '@lapilli-ui/components';
import { useButtonData, getPrivacyOptions } from '../../../../utils';
import { useMoveToAnotherWishlistModalData } from './hooks/use-move-to-another-wishlist.modal-data'

const MoveToAnotherWishlistModal = ( { className } ) => {
	const {
		modalIcon,
		moveModalWishlistId,
		moveModalWishlistNameError,
		moveModalWishlistName,
		moveModalType,
		moveModalWishlistPrivacy,
		isMoveModalOpened,
		moveModalWishlistSelectError,
	} = useButtonData();

	const {
		className: modalClasses,
		handleClose,
		chooseOptions,
		originWishlistName,
		handlePrivacyChange,
		handleRemoveFromWishlist,
		handleWishlistSelectChange,
		handleMoveToAnotherWishlist,
		handleWishlistNameInputChange,
	} = useMoveToAnotherWishlistModalData();

	const classes = {
		modal: classnames( className, modalClasses ),
		title: 'yith-wcwl-move-to-another-wishlist-modal__title'
	};
	const getSelectValue = () => {
		if ( 'create' === moveModalType )
			return 'create'

		return moveModalWishlistId > 0 ? moveModalWishlistId : undefined;
	};

	return <Modal
		open={ isMoveModalOpened }
		onClose={ handleClose }
		classes={ classes }
		icon={ 'default' === modalIcon ? 'heart-arrows-light' : modalIcon }
		title={ __( 'Move to another wishlist', 'yith-woocommerce-wishlist' ) }
	>
		<ModalContent className={ 'yith-wcwl-modal__content yith-wcwl-move-to-another-wishlist-modal__content' }>
			<div className={ 'yith-wcwl-move-to-another-wishlist-modal__content__desc' }>
				{ reactStringReplace( __( 'This item is already in {{wishlist_name}} list.', 'yith-woocommerce-wishlist' ), '{{wishlist_name}}', ( match, i ) => <strong key={ i }>"{ originWishlistName }"</strong> ) }
				<br/>
				{ __( 'Move it to another list:', 'yith-woocommerce-wishlist' ) }
			</div>
			<Select
				options={ chooseOptions }
				placeholder={ __( 'Choose a wishlist' ) }
				error={ moveModalWishlistSelectError }
				onChange={ handleWishlistSelectChange }
				value={ getSelectValue() }
				defaultValue={ chooseOptions[ 0 ]?.value }
			/>
			{
				'create' === moveModalType &&
				<>
					<Input
						placeholder={ yithWcwlAddToWishlist.i18n.modals.add_to_wishlist.wishlist_name_input_placeholder }
						value={ moveModalWishlistName }
						onChange={ handleWishlistNameInputChange }
						error={ moveModalWishlistNameError }
						fullWidth={ true }
					/>
					<RadioGroup
						options={ getPrivacyOptions( true ) }
						value={ moveModalWishlistPrivacy }
						onChange={ handlePrivacyChange }
					/>
				</>
			}
		</ModalContent>
		<ModalActions className={ 'yith-wcwl-modal__actions yith-wcwl-move-to-another-wishlist-modal__actions' }>
			<Button className={ classnames( yithWcwlAddToWishlist.buttonClasses, 'yith-wcwl-modal__primary-button' ) } onClick={ handleMoveToAnotherWishlist } size={ 'lg' }>
				{ __( 'Move', 'yith-woocommerce-wishlist' ) }
			</Button>
			<span className={ 'yith-wcwl-move-to-another-wishlist-modal__remove-wrapper' }>
					{ __( 'or', 'yith-woocommerce-wishlist' ) }
				<a role={ 'button' } className={ 'yith-wcwl-move-to-another-wishlist-modal__remove' } onClick={ handleRemoveFromWishlist }>
						{ __( 'remove it from your list', 'yith-woocommerce-wishlist' ) }
					</a>
				</span>
		</ModalActions>
	</Modal>
}

export default MoveToAnotherWishlistModal;